/**
 * 鸡蛋配置
 * @constructor
 */
export default function EggConfig() {
    const dataList : EggEntity[] = [
        //土鸡蛋
        // {
        //     goodsId : 21001,
        //     skin : "PuTong",
        //     hatchingSeconds:120,
        //     hatchingSpecies :[
        //         { chickenId : -1 , weight : 40 },
        //         { chickenId : 1 , weight : 30 },
        //         { chickenId : 3 , weight : 20 },
        //         { chickenId : 5 , weight : 10 },
        //     ],
        // },
        // {
        //     goodsId : 21002,
        //     skin : "Jin",
        // },
        // {
        //     goodsId : 21003,
        //     skin : "Yin",
        // },
        // //恐龙蛋
        // {
        //     goodsId : 21004,
        //     skin : "KongNiao",
        //     hatchingSeconds:120,
        //     hatchingSpecies :[
        //         { chickenId : -1 , weight : 40 },
        //         { chickenId : 7 , weight : 60 },
        //     ],
        // },
        // //凤凰
        // {
        //     goodsId : 21005,
        //     skin : "FongHuang",
        //     hatchingSeconds:30,
        //     hatchingSpecies :[
        //         { chickenId : 9 , weight : 100 },
        //     ],
        // },
        // //龙蛋
        // {
        //     goodsId : 21006,
        //     skin : "QiLin",
        //     hatchingSeconds:300,
        //     hatchingSpecies :[
        //         { chickenId : 10 , weight : 100 },
        //     ],
        // },
        // //麒麟蛋
        // {
        //     goodsId : 21007,
        //     skin : "QiLin",
        // },
    ];
    return dataList;
}

/**
 * 蛋实体
 */
export class EggEntity{
    goodsId : number;//背包 物品id
    skin : string;//皮肤
    hatchingSeconds ?: number;//孵化秒数
    hatchingSpecies ?: { chickenId : number , weight : number }[];//孵化 选项 数组
}

/**
 * 通过id获取
 * @param eggId
 */
export function getEggById( eggId : number ){
    return EggConfig().find(( item,index, dataList )=>{
        return item.goodsId == eggId;
    });
}
